import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tvt-logistics-india-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss'],
})
export class ServicesComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
